export const articleReducer = (articles = [], action) => {
  const { type, payload } = action;

  switch (type) {
    case "PUBLISH":
      return {
        ...articles,
        articles: [...articles.articles, payload],
      };
    case "LOAD":
      return {
        ...articles,
        articles: payload,
      };

    default:
      return articles;
  }
};
